import styled from "styled-components";

export const SecurityWrapper = styled.div`
  border-radius: 10px;
  background: ${({ theme }) => theme.card.bg.secondary};
  padding: 20px 15px;

  .authentication-container {
    margin-bottom: 33px;
  }
`;
